import React from "react";
import { SkeletonOne, SkeletonTwo, SkeletonThree, SkeletonFour } from "./Skeletons";

const AboutUs = () => {
  const features = [
    {
      title: "Our Mission",
      description: "Empowering and growing new business owners and start-ups and through bespoke, tailored digital solutions.",
      skeleton: <SkeletonOne />,
      className: "col-span-1 lg:col-span-4 border-b lg:border-r dark:border-neutral-800",
    },
    {
      title: "Partnering with Innovation",
      description: "Working cooperatively with clients as partners to create amazing websites and grow their online presence.",
      skeleton: <SkeletonTwo />,
      className: "col-span-1 lg:col-span-2 border-b dark:border-neutral-800",
    },
    {
      title: "Global Reach",
      description: "Kura means growth, and we aim to grow businesses on both a local and global scale.",
      skeleton: <SkeletonFour />,
      className: "col-span-1 lg:col-span-3 lg:border-r dark:border-neutral-800",
    },
    {
      title: "Your Vision, Realised",
      description: "Encouraging regular feedback loops and aligning on creative direction to deliver on your vision.",
      skeleton: <SkeletonThree />,
      className: "col-span-1 lg:col-span-3 border-b lg:border-none",
    },
  ];

  return (
    <div className="relative z-20 py-10 lg:py-40 max-w-7xl mx-auto">
      <div className="px-8">
        <h4 className="text-3xl lg:text-5xl lg:leading-tight max-w-5xl mx-auto text-center tracking-tight font-medium text-black dark:text-white">
          About Us
        </h4>
        <p className="text-sm lg:text-base max-w-2xl my-4 mx-auto text-neutral-500 text-center font-normal dark:text-neutral-300">
          Discover what sets Kura Digital apart and how we help businesses thrive.
        </p>
      </div>

      <div className="relative">
        <div className="grid grid-cols-1 lg:grid-cols-6 mt-12 xl:border rounded-md dark:border-neutral-800">
          {features.map((feature) => (
            <FeatureCard key={feature.title} className={feature.className}>
              <FeatureTitle>{feature.title}</FeatureTitle>
              <FeatureDescription>{feature.description}</FeatureDescription>
              <div className="h-full w-full">{feature.skeleton}</div>
            </FeatureCard>
          ))}
        </div>
      </div>
    </div>
  );
};

const FeatureCard = ({ children, className }) => {
  return <div className={`p-4 sm:p-8 relative overflow-hidden ${className}`}>{children}</div>;
};

const FeatureTitle = ({ children }) => {
  return (
    <p className="max-w-5xl mx-auto text-left tracking-tight text-black dark:text-white text-xl md:text-2xl md:leading-snug">
      {children}
    </p>
  );
};

const FeatureDescription = ({ children }) => {
  return (
    <p className="text-sm md:text-base max-w-4xl text-left mx-auto text-neutral-500 font-normal dark:text-neutral-300">
      {children}
    </p>
  );
};

export default AboutUs;










